import React from 'react';

export default [
  {
    id: '52',
    en: {
      isTradingRank: false,
      name: 'CHZ',
      symbol: 'CHZ_BTC',
      pageTitle: '$50,000 in CHZ, With 6 VIP Atletico Madrid Match Tickets to Give Away!',
      pageDescription: `To celebrate CHZ being listed on Binance.com, Binance and the Chiliz team have committed $50,000 in CHZ,
      which includes 6 VIP football entry tickets to the Socios.com SkyBox (valued at $2,000 USD each) for the Atletico Madrid vs.
      Real Madrid match taking place on Sept. 28th, 2019, live at the Wanda Metropolitano Stadium in Madrid, Spain. `,
      banner: {
        pc: {
          height: 500,
          path: './images/pc/chz-banner-en.jpg',
        },
        mobile: {
          height: 234,
          path: './images/mobile/chz-banner-en.jpg',
        },
      },
      time: 'Competition period: 2019/09/18 0:00 AM to 2019/09/23 0:00 AM (UTC).',
      description: (
        <>
          To celebrate CHZ being listed on Binance.com, Binance and the Chiliz team have committed
          $50,000 in CHZ, which includes <strong>6 VIP</strong> football entry tickets to the
          Socios.com
          <strong>SkyBox (valued at $2,000 USD each)</strong> for the
          <strong>Atletico Madrid vs. Real Madrid</strong>
          match taking place on Sept. 28th, 2019, live at the Wanda Metropolitano Stadium in Madrid,
          Spain.
        </>
      ),
      partA: {
        title: '10% Lifetime Trading Fee Discount For New Registered Users',
        desc: (
          <>
            All new users that register on Binance using this
            <a href="https://www.binance.com/en/register?ref=NI4E0CX2"> special referral link </a>
            will enjoy a lifetime <strong>10%</strong> trading fee discount.
          </>
        ),
        rewards: [],
      },
      partB: {
        title:
          'CHZ Trading Competition, $50,000 in CHZ, With 6 VIP Atletico Madrid Match Tickets to Win',
        desc: (
          <>
            <p>
              Users with CHZ effective trading volume of 15,000 CHZ or more during the competition
              period will be put into a Lucky Draw.
            </p>
            <ul style={{ margin: '0 0 40px 40px' }}>
              <li>
                Binance will randomly select 6 lucky winners from this pool, with each winner
                receiving $3,000 in CHZ tokens and 1 VIP football entry ticket to the Socios.com
                SkyBox <strong>(or $2,000 USD equivalent convertible value in CHZ)</strong> for the
                Atletico Madrid vs. Real Madrid match taking place on Sept. 28th, 2019 at the Wanda
                Metropolitano Stadium in Madrid, Spain.
              </li>
              <li>
                Binance will also randomly select 20 additional lucky winners from this pool, with
                each winner receiving $1,000 CHZ in CHZ tokens.
              </li>
            </ul>
            <p>
              To ensure fairness and transparency of the draw, we will broadcast the lucky draw live
              on multiple social media platforms. The live draw time will be announced at a later
              date.
            </p>
          </>
        ),
        rewards: [],
      },
      terms: [
        'Effective trading volume consists of buys and sells (excluding wash trades) in CHZ/BNB, CHZ/BTC, CHZ/USDT trading pairs.',
        `Each sub-account and margin account trading volume will be combined with users' standard trading volume in the final
        calculation. However, each sub-account will not be viewed as an independent account when participating in this activity.`,
        `The football match tickets are for the Socios.com SkyBox to watch the Atletico Madrid vs. Real Madrid match taking place
        on Sept. 28th, 2019.`,
        `Binance will use the CHZ/USDT price of at the start of the competition period as the exchange rate between USDT
        and CHZ.`,
        'Binance reserves the right to disqualify trades which are deemed unfair or display attributes of market manipulation.',
        'Binance reserves the right to cancel or amend the competition or competition rules at our sole discretion.',
        'Participants will not be eligible to win multiple prizes within a single competition.',
        `CHZ rewards will be issued within 2 weeks after the competition ends. You will be able to login and see your
        prize via Distribution History > Account Center. Winners of SkyBox tickets for Atletico Madrid vs.
        Real Madrid match taking place on Sept. 28th, 2019 who wish to redeem these
        tickets will be contacted ahead of match day by Socios.com. `,
      ],
      riskTip: `Cryptocurrency investment is subject to high market risk. Binance is not responsible for any direct,
      indirect or consequential losses as a result of the trading competition. Please make your investments with caution.`,
    },
    cn: {
      isTradingRank: false,
      name: 'CHZ',
      symbol: 'CHZ_BTC',
      pageTitle: 'CHZ交易大赛，赢取5万美元CHZ幸运奖+6张VIP足球比赛门票',
      pageDescription: `为庆祝CHZ上线Binance，以及土耳其最火的足球俱乐部在在ChiliZ 发币。Binance 联手Chilize团队举办交易活动，
      送出5万美元等值的CHZ幸运奖和6张VIP足球比赛门票。`,
      banner: {
        pc: {
          height: 500,
          path: './images/pc/chz-banner-cn.jpg',
        },
        mobile: {
          height: 234,
          path: './images/mobile/chz-banner-cn.jpg',
        },
      },
      time: '活动时间：2019年09月18日上午8:00至2019年09月23日上午8:00（香港时间）',
      description:
        '为庆祝CHZ上线Binance，以及土耳其最火的足球俱乐部在在ChiliZ 发币。Binance 联手Chilize团队举办交易活动，送出5万美元等值的CHZ幸运奖和6张VIP足球比赛门票。',
      partA: {
        title: '迎新奖，专享9折手续费优惠',
        desc: (
          <>
            活动期间，通过
            <a href="https://www.binance-cn.com/cn/register?ref=NI4E0CX2">专属邀请链接</a>
            注册Binance, 即可获得9折手续费优惠。
          </>
        ),
        rewards: [],
      },
      partB: {
        title: '交易CHZ，赢5万美金等值幸运奖+6张VIP足球比赛门票',
        desc: (
          <>
            <p>活动期间，凡在Binance官网参与CHZ交易满15,000 CHZ 的用户，就有机会参与抽奖。</p>
            <ul style={{ margin: '0 0 40px 40px' }}>
              <li>
                随机抽6位用户，每人奖励3,000美金等值的CHZ +
                1张2,000美元等值的CHZ的VIP足球门票--2019年9月28日马德里竞技对皇家马德里比赛。
              </li>
              <li>随机抽20名用户用户，平分40,000美金等值的CHZ。</li>
            </ul>
            <p>
              为了保证公正透明, Binance 将会在YouTube
              和微博进行直播。直播信息请关注Binance官方社交媒体信息。
            </p>
          </>
        ),
        rewards: [],
      },

      terms: [
        '美元和CHZ的汇率以活动开始第一天的CHZ/USDT交易对的开盘为准。',
        '有效交易量：买入及卖出总量，不含账号对倒量',
        '子账号和杠杆账号的交易量计入主账号，子账号不再作为独立账号参与活动',
        '奖励发放：活动结束后2周内发放，可在用户中心-分发记录查看',
        '活动最终解释权归Binance所有',
      ],
      riskTip:
        '数字货币是一种高风险的投资方式，请投资者谨慎购买，并注意投资风险。Binance会遴选优质币种，但不对投资行为承担担保、赔偿等责任。',
    },
  },
  {
    id: '53',
    en: {
      isTradingRank: true,
      name: 'NPXS',
      symbol: 'NPXS_BTC',
      pageTitle: 'NPXS Trading Competition - $150,000 in NPXS To Give Away!',
      pageDescription: `To celebrate Pundi X's 2nd anniversary
      and NPXS being listed on Binance for one year,
      Binance and Pundi X have committed to a total of $150, 000 in NPXS tokens to give away to our users worldwide.`,
      banner: {
        pc: {
          height: 500,
          path: './images/pc/NPXS_landing-EN.jpg',
        },
        mobile: {
          height: 234,
          path: './images/mobile/NPXS_app-EN.jpg',
        },
      },
      time: 'Promotion period: 2019/09/27 0:00 AM to 2019/10/04 0:00 AM (UTC).',
      updataTime: 'Update: Data will now be updated at 2:30 AM(UTC) on the following day.',
      description: (
        <>
          To celebrate Pundi X&apos;s 2nd anniversary and NPXS being listed on Binance for one year,
          Binance and Pundi X have committed to a total of <strong>$150,000</strong> in NPXS tokens
          to give away to our users worldwide.
        </>
      ),
      partA: {
        title: '10% Lifetime Trading Fee Discount For New Registered Users',
        desc: (
          <>
            All new users that register on Binance using this
            <a href="https://www.binance.com/en/register?ref=NI4E0CX2"> special referral link </a>
            will enjoy a lifetime <strong>10%</strong> trading fee discount.
          </>
        ),
        rewards: [],
      },
      partB: {
        title: 'Trade NPXS, $150,000 In NPXS Token To Win!',
        desc: (
          <>
            <p>
              All users will be ranked in terms of the total NPXS trading volume traded on their
              Binance account (including both Buys and Sells) across all NPXS trading pairs during
              the competition period.
            </p>
          </>
        ),
        rewards: [
          {
            orderNo: '1',
            title: '1st Place',
            desc: '1st Place will receive $30,000 in NPXS tokens',
          },
          {
            orderNo: '2',
            title: '2nd Place',
            desc: '2nd Place will receive $10,000 in NPXS tokens',
          },
          {
            orderNo: '3',
            title: '3rd Place',
            desc: '3rd Place will receive $5,000 in NPXS tokens',
          },
          {
            orderNo: '4',
            title: '4th-10th Place',
            desc: 'equally split a pool of $20,000 in NPXS tokens',
          },
          {
            orderNo: '5',
            title: '11th-20th Place',
            desc: 'equally split a pool of $15,000 in NPXS tokens',
          },
          {
            orderNo: '6',
            title: '21st-100th Place',
            desc: 'equally split a pool of $70,000 in NPXS tokens',
          },
        ],
      },
      terms: [
        'Trading volume counts both buys and sells, excluding any wash trades.',
        'Binance reserves the right to disqualify trades which are deemed to be wash trades or display attributes of market manipulation.',
        `Each sub-account and margin account
        trading volume will be combined with users'
        standard trading volume in the
        final calculation. However, each sub-account will not be viewed as an independent account when participating in this activity.`,
        'Binance reserves the right to cancel or amend any Activity or Activity Rules at our sole discretion.',
      ],
      riskTip: `Cryptocurrency investment is subject to high market risk. Binance is not responsible for any direct,
      indirect or consequential losses as a result of the trading competition. Please make your investments with caution.`,
    },
    cn: {
      isTradingRank: true,
      name: 'NPXS',
      symbol: 'NPXS_BTC',
      pageTitle: 'NPXS交易大赛，赢取15万美元等值NPXS',
      pageDescription:
        '为庆祝NPXS发行2周年，Binance和Pundi X联手举办NPXS活动，感谢社区的持续支持。',
      banner: {
        pc: {
          height: 500,
          path: './images/pc/NPXS_landing-CH.jpg',
        },
        mobile: {
          height: 234,
          path: './images/mobile/NPXS_app-CN.jpg',
        },
      },
      time: '活动时间：2019年09月27日上午8:00-2019年10月04日上午8:00（香港时间）',
      description: '为庆祝NPXS发行2周年，Binance和Pundi X联手举办NPXS活动，感谢社区的持续支持。',
      updataTime: '数据更新：次日上午10:30后更新（香港时间）',
      partA: {
        title: '迎新奖，专享9折手续费优惠',
        desc: (
          <>
            活动期间，通过
            <a href="https://www.binance-cn.com/cn/register?ref=NI4E0CX2">专属邀请链接</a>
            注册Binance, 即可获得9折手续费优惠。
          </>
        ),
        rewards: [],
      },
      partB: {
        title: '交易NPXS，赢取15万美元等值NPXS大奖',
        desc: (
          <>
            <p>
              活动期间，凡在Binance官网参与NPXS交易，将根据有效交易量（买入+卖出）排名。奖励规则如下：
            </p>
          </>
        ),
        rewards: [
          { orderNo: '1', title: '第1名', desc: '30,000 美元等值NPXS' },
          { orderNo: '2', title: '第2名', desc: '10,000 美元等值NPXS' },
          { orderNo: '3', title: '第3名', desc: '5,000 美元等值NPXS' },
          { orderNo: '4', title: '第4-10名', desc: '平分20,000 美元等值NPXS' },
          { orderNo: '5', title: '第11-20名', desc: '平分15,000 美元等值NPXS' },
          { orderNo: '6', title: '第21-100名', desc: '平分70,000 美元等值NPXS' },
        ],
      },

      terms: [
        '有效交易量：买入及卖出总量，不含账号对倒量。',
        '活动期间，如有恶意刷量行为，将取消参赛资格。',
        '子账号不作为独立账号参与活动。子账号和杠杆账号的量也计算入主账号。',
        '奖励发放：活动奖励将在活动结束后2周内发放，可在用户中心-分发记录查看。',
        '活动最终解释权归Binance所有。',
      ],
      riskTip:
        '数字货币是一种高风险的投资方式，请投资者谨慎购买，并注意投资风险。Binance会遴选优质币种，但不对投资行为承担担保、赔偿等责任。',
    },
  },
  {
    id: '54',
    en: {
      isTradingRank: true,
      name: 'DOCK',
      symbol: 'DOCK_USDT',
      pageTitle: 'DOCK Trading Competition, 35 BTC to Give Away!',
      pageDescription: 'DOCK Trading Competition, 35 BTC to Give Away!',
      banner: {
        pc: {
          height: 500,
          path: './images/pc/DOCK_landing_page-EN.jpg',
        },
        mobile: {
          height: 234,
          path: './images/mobile/DOCK_app-EN.jpg',
        },
      },
      time: 'Promotion period: 2019/10/15 0:00 AM to 2019/10/22 0:00 AM (UTC).',
      updataTime: 'Update: Data will now be updated at 2:30 AM(UTC) on the following day.',
      description: <></>,
      partA: {
        title: 'Promotion A:10% Lifetime Trading Fee Discount For New Registered Users',
        desc: (
          <>
            All new users that register on Binance using this
            <a href="https://www.binance.com/en/register?ref=FFPG51BU"> special referral link </a>
            will enjoy a <strong>10%</strong> trading fee discount.
          </>
        ),
        rewards: [],
      },
      partB: {
        title: 'Promotion B: DOCK Trading Competition - 25 BTC to Win!',
        desc: (
          <>
            <p>
              The top 20 DOCK traders will share a pool of 25 BTC based on the proportion of their
              own DOCK trading volume against the total trading volume of the top 20 traders during
              the competition period. This includes buys and sells across all DOCK trading pairs.
            </p>
            <p>
              <strong>Reward Calculation</strong>：
            </p>
            <p>
              Rewards for each user in the top 20 = (Each user’s total trading volume / Top 20
              users’ total trading volume) × 25 BTC
            </p>
          </>
        ),
        rewards: [],
      },
      partC: {
        title: 'Promotion C: Lucky Ranking - 10 BTC to Win! ',
        desc: (
          <>
            <p>
              Users ranked 21st, 31th, 41th, and so forth until 1,991th place of the top 2,000 DOCK
              traders based on the trading volume (including buys and sells) during the competition
              period will equally split a total of 10 BTC.
            </p>
          </>
        ),
        rewards: [],
      },
      terms: [
        'Users are not eligible for multiple rewards in both Promotion B and Promotion C.',
        'Trading volume counts both buys and sells, excluding any wash trades.',
        'The 10% trading fee discount will remain valid as long as the discount program is in place',
        'Binance reserves the right to disqualify trades which are deemed to be wash trades or display attributes of market manipulation',
        `Each sub-account and margin account trading volume will be combined with users' standard
        trading volume in the final calculation.However, each sub - account will not be viewed as an independent account when participating in this activity.`,
        'Binance reserves the right to cancel or amend any Activity or Activity Rules at our sole discretion.',
        `Rewards will be distributed within 2 weeks after the competition ends.
         You will be able to login and see your rewards via Distribution History > Wallet > Account Center.`,
      ],
      riskTip: `Cryptocurrency investment is subject to high market risk. Binance is not responsible
      for any direct, indirect or consequential losses as a result of the trading competition. Please make your investments with caution.`,
    },
    cn: {
      isTradingRank: true,
      name: 'DOCK',
      symbol: 'DOCK_USDT',
      pageTitle: 'DOCK社区回馈，壕送35BTC百万大奖',
      pageDescription:
        '为了感谢社区对DOCK的支持，Binanc联合DOCK举办交易大赛，送出35BTC豪礼，价值百万。',
      banner: {
        pc: {
          height: 500,
          path: './images/pc/DOCK_landing_page-CN.jpg',
        },
        mobile: {
          height: 234,
          path: './images/mobile/DOCK_app-CN.jpg',
        },
      },
      time: '活动时间：2019年10月15日上午8:00- 2019年10月22日上午8:00 (香港时间）',
      description:
        '为了感谢社区对DOCK的支持，Binanc联合DOCK举办交易大赛，送出35BTC豪礼，价值百万。',
      updataTime: '数据更新：次日上午10:30后更新（香港时间）',
      partA: {
        title: '迎新奖：新用户专享9折手续费优惠',
        desc: (
          <>
            活动期间，通过
            <a href="https://www.binancezh.com/cn/register?ref=FFPG51BU">专属邀请链接</a>
            注册Binance, 即可获得9折手续费优惠。
          </>
        ),
        rewards: [],
      },
      partB: {
        title: '实力奖：交易DOCK，壕送25BTC大奖',
        desc: (
          <>
            <p>
              活动期间，凡在Binance官网参与DOCK交易，根据有效交易量（买入+卖出）排名。排名前20的用户，按照前20位用户总交易量的占比，瓜分25BTC奖励，你的最终奖励由你自己决定。
            </p>
            <p>
              <strong>获奖细则</strong>：
            </p>
            <p>单个用户的奖励 =（用户个人总交易量/Top20用户的总交易量）× 25BTC</p>
          </>
        ),
        rewards: [],
      },
      partC: {
        title: '幸运奖：交易DOCK，平分10BTC大奖',
        desc: (
          <>
            <p>活动期间，交易量排名Top 2,000 内且排名尾数为1的用户，平分10 BTC大奖。</p>
          </>
        ),
        rewards: [],
      },
      terms: [
        '9折手续费的优惠时效性取决于Binance返佣的时效性。',
        '有效交易量：买入及卖出总量，不含账号对倒量。',
        '活动期间，如有恶意刷量行为，将取消参赛资格。',
        '子账号不作为独立账号参与活动。子账号和杠杆账号的量也计算入主账号。',
        '实力奖用户和幸运奖用户不重复中奖',
        '奖励发放：活动奖励将在活动结束后2周内发放，可在用户中心-钱包-分发记录查看。',
        '活动最终解释权归Binance所有。',
      ],
      riskTip:
        '数字货币是一种高风险的投资方式，请投资者谨慎购买，并注意投资风险。Binance会遴选优质币种，但不对投资行为承担担保、赔偿等责任。',
    },
  },
];
